export default {
  data: function () {
    return {
      currentSortDirection: 1
    }
  },
  methods: {
    sortRow: function (row) {
      // prepnuti smeru pokud klikne na stejny nadpis podruhe, jinak priradim defaultni smer
      if (row == this.currentSortRow) {
        
        this.currentSortDirection = this.currentSortDirection == 1 ? -1 : 1;
      } else {
        this.currentSortDirection = 1;
      }
      // a vybiram, podle ceho radim
      this.currentSortRow = row;
    },
    lowerCaseMe(iAmAStringAndIAmAlive) {
      if (typeof iAmAStringAndIAmAlive == "boolean") {
        return iAmAStringAndIAmAlive
    }
      if (!isNaN(parseInt(iAmAStringAndIAmAlive))) {
        return iAmAStringAndIAmAlive
      }


      if (iAmAStringAndIAmAlive == '' || typeof iAmAStringAndIAmAlive == 'undefined')
        throw 'Spatne nastaveny sloupec podle ktereho se ma radit.'

      return iAmAStringAndIAmAlive.toLowerCase()
    }
  },
  computed: {
    sortedData: function () {
      try {
        // ver2 popis: pokud potrebuju sortovat podle jineho arraye, nez ktery zobrazuju, pouziju tohle ve forme:
        // A#B#C, kde
        // A - nazev polozky, jejiz hodnotu chci pouzit na sortovani
        // B - nazev arraye, ve kterym se nachazi hodnota, podle ktere chci sortit
        // C - nazev polozky, podle ktere chci z arraye B sortit
        // dulezita poznamka je, ze se aktualne pocita s propojenim pomoci id, respektive ze A je hodnota B ve sloupci id, pomoci ktereho hledam
        //
        // ver1 popis: pokud se sortuje podle jineho arraye, nez je nazev (productid - productcategory napriklad)
        if (this.currentSortRow.includes("#")) {
          var rowData = this.currentSortRow.split("#")
          var sortedRow = rowData[0];
          var sortByArray = rowData[1];
          var sortByRow = rowData[2];
          var sortedData = this.sourceData.slice().sort((a, b) => {
            if (this.lowerCaseMe(this[sortByArray].filter(({ id }) => id == [a[sortedRow]])[0][sortByRow]) < this.lowerCaseMe(this[sortByArray].filter(({ id }) => id == [b[sortedRow]])[0][sortByRow])) {
              return -1 * this.currentSortDirection;
            } else if (this.lowerCaseMe(this[sortByArray].filter(({ id }) => id == [a[sortedRow]])[0][sortByRow]) > this.lowerCaseMe(this[sortByArray].filter(({ id }) => id == [b[sortedRow]])[0][sortByRow])) {
              return 1 * this.currentSortDirection;
            } else {
              return 0;
            }
          });
          return sortedData;
        }
        
        // pokud je to soucasti arraye, jen o jedno niz
        else if (this.currentSortRow.includes(".")) {
          var arrayData = this.currentSortRow.split(".")

          return this.sourceData.slice().sort((a, b) => {
            var first = a
            var second = b
            arrayData.forEach(element => {
              first = first[element]
              second = second[element]
            });
            if (this.lowerCaseMe(first) < this.lowerCaseMe(second)) {
              return -1 * this.currentSortDirection;
            } else if (this.lowerCaseMe(first) > this.lowerCaseMe(second)) {
              return 1 * this.currentSortDirection;
            } else {
              return 0;
            }
          });
        }
        // jinak proste sortuju podle zadaneho arraye
        else {
          return this.sourceData.slice().sort((a, b) => {
            if (this.lowerCaseMe(a[this.currentSortRow]) < this.lowerCaseMe(b[this.currentSortRow])) {
              return -1 * this.currentSortDirection;
            } else if (this.lowerCaseMe(a[this.currentSortRow]) > this.lowerCaseMe(b[this.currentSortRow])) {
              return 1 * this.currentSortDirection;
            } else {
              return 0;
            }
          });
        }
      } catch (e) {
        window.console.error(this.$options.name + ': ' + e + ' Bylo sortovano podle "' + this.currentSortRow + '".')
      }
    }
  }
};
